import { Component } from '@angular/core';


@Component({
    selector: 'app-settings-menu-app',
    templateUrl: './settings-menu.component.html',
    styleUrls: ['./settings-menu.component.scss'],
    standalone: false
})
export class SettingsMenuAppComponent {

  constructor() {
  }
}
